var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cmpCreate',{attrs:{"name":_vm.name,"pkColumn":_vm.pkColumn,"fields":_vm.fields,"parent":_vm.parent,"header":_vm.header}})
}
var staticRenderFns = []

export { render, staticRenderFns }